export class MessagingSubscriptionRequest {

  public uri: string;
  public type: string;
  public action: string;
}
